import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
	selector: 'app-mapa-sitio',
	templateUrl: 'mapa-sitio.component.html'
})
export class MapaSitioComponent implements OnInit {
  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="Mapa de sitio | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Mapa de sitio | Sinuberase",
  		description: "Listado con todas las páginas y/o secciones del sitio web de Sinuberase",
  		slug: "Mapa-de-sitio"
  	})

		this.seo.closeMenu();
	}
}